import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.custom-app-integration', {
        url: '/custom-app-integration',
        component: 'companyCustomAppIntegration',
        resolve: {
            applications,
        },
    });
}

/** @ngInject */
function applications(ApplicationsResource, companyId) {
    return ApplicationsResource.getAllCustomApplicationsForCompany(companyId);
}



// WEBPACK FOOTER //
// ./src/portal/states/company/custom-application-integration/custom-application-integration.state.js